import * as React from 'react';
import { assertions } from 'lib/assertions';
import EventTracking from 'lib/EventTracking';
import Button from 'components/ButtonDeprecated';
import Checkbox from 'components/Checkbox';
import FormElement from 'components/FormElement';
import Icon from 'components/Icon';
import Input from 'components/Input';
import Link from 'components/Link';
import Row from 'components/Row';
import Text from 'components/Text';

import { CookieWarning, getPersistFromCookie } from './cookieUtils';

export type Props = {
  onPasswordChange: (password?: string) => void;
  uid?: string;
  submitIsDisabled: boolean;
  onSubmit: () => void;
  persist: boolean;
  togglePersistChange: () => void;
  onGoBack?: () => void;
};

const eventPrefix = 'sign_in.password_page';

export default function EnterPassword({
  onPasswordChange,
  uid,
  submitIsDisabled,
  onSubmit,
  persist,
  togglePersistChange,
  onGoBack,
}: Props) {
  React.useEffect(() => {
    EventTracking.trackKey(`${eventPrefix}.view`);
  }, []);

  return (
    <React.Fragment>
      {onGoBack && (
        <Row size="small">
          <Text align="left">
            <Link eventKey={`${eventPrefix}.back.click`} onClick={onGoBack}>
              <Icon name="arrow-left" />
              {` Back`}
            </Link>
          </Text>
        </Row>
      )}
      <form
        data-test="sign-in-password-form"
        onSubmit={e => {
          e.preventDefault();
          onSubmit();
        }}>
        <CookieWarning />
        <FormElement
          data-test="password-field"
          label="Password"
          validate={e => {
            assertions.notEmpty(e.target.value, 'You must enter a password.');
          }}
          onValidChange={e => onPasswordChange(e.target.value)}
          onInvalidChange={() => onPasswordChange(undefined)}
          element={Input}
          elementProps={{
            autocomplete: 'current-password',
            onClick: () => {
              EventTracking.trackKey(`${eventPrefix}.enter_password.click`);
            },
            name: 'password',
            placeholder: 'Password',
            size: 'large',
            required: true,
            autofocus: !!uid,
            type: 'password',
            append: (
              <Link
                to={{ pathname: '/forgot_password', query: uid ? { email: uid } : null }}
                className="SignInForm-forgotPassword">
                Forgot?
              </Link>
            ),
          }}
        />
        <Row size="small">
          <Checkbox
            data-test="persist-checkbox"
            name="persist"
            checked={persist}
            onChange={togglePersistChange}
            label="Stay logged in"
          />
        </Row>
        <Button
          data-test="submit-button"
          eventProperties={getPersistFromCookie() ? { state: 'stay_logged_in' } : {}}
          eventKey={`${eventPrefix}.continue.click`}
          type="submit"
          level="primary"
          full
          disabled={submitIsDisabled}>
          Continue
        </Button>
      </form>
    </React.Fragment>
  );
}
